// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"f47a58ec","136":"bd7da27b","162":"80ef35d0","383":"fda2a3fe","453":"ffbafa61","604":"4882ac31","627":"d49383d9","793":"f0c58ba4","811":"88a30030"}[chunkId] + ".chunk.js";
};